import customFetch from '../../utils/customFetch'
import { API_ENDPOINT } from '../../config'
import { Contacts } from '../../@types/types'
import NotLoggedInError from '../../services/domain/errors/NotLoggedInError'
import { getDefaultLogger } from '../../services/logger/logger'
import { contactsToApp } from './converters/contactsToApp'

export const getContacts: () => Promise<Contacts> = async () => {
  const options = {
    method: 'GET',
    headers: {
      Accept: 'application/json; charset=utf-8',
      'Content-Type': 'application/json; charset=UTF-8',
    },
    credentials: 'include',
  }

  try {
    const response = await customFetch(`${API_ENDPOINT}/anbieten/private-anbieter/inserieren/api/contacts`, options)
    if (response.status === 200) {
      return contactsToApp(await response.json())
    }
    return Promise.reject(new Error())
  } catch (error) {
    getDefaultLogger().warn(`Cannot load agent contacts -failed with ${error}`)
    throw new NotLoggedInError()
  }
}
